import { render, staticRenderFns } from "./disclaimer02.vue?vue&type=template&id=100cfcd8&"
import script from "./disclaimer02.vue?vue&type=script&lang=js&"
export * from "./disclaimer02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports